import FormattedMessage from 'I18n/components/FormattedMessage';
import { UnreachableI18nCaseError } from '../../utils/i18nUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalEditPanelSubheadingI18n = ({
  approvalType
}) => {
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.stepOneSubheading.MARKETING_EMAIL"
        });
      }
    case 'LANDING_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.stepOneSubheading.LANDING_PAGE"
        });
      }
    case 'SITE_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.stepOneSubheading.SITE_PAGE"
        });
      }
    case 'BLOG_POST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.stepOneSubheading.BLOG_POST"
        });
      }
    case 'DEAL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.stepOneSubheading.DEAL"
        });
      }
    case 'KNOWLEDGE_ARTICLE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.stepOneSubheading.KNOWLEDGE_ARTICLE"
        });
      }
    case 'QUOTE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.stepOneSubheading.QUOTE"
        });
      }
    case 'SOCIAL_BROADCAST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.stepOneSubheading.SOCIAL_BROADCAST"
        });
      }
    case 'CONNECTED_APP':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.stepOneSubheading.CONNECTED_APP"
        });
      }
    default:
      throw new UnreachableI18nCaseError(approvalType);
  }
};